import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { Divider } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  applicationFilesMaxFileSizeInMB,
  applicationFilesUnit,
} from '../application-version-fields/applicationVersionFields.util';
import { DeviceAppVersionCard } from '../device-app-version-card/DeviceAppVersionCard.ctrl';
import {
  SystemPackageVersionApplicationFilesField,
  SystemPackageVersionSelectField,
} from '../system-package-version-fields/SystemPackageVersionFields.ctrl';
import type { SystemPackageVersionBuildStepProps } from './systemPackageVersionBuildStep.model';
import { useSystemPackageVersionBuildStep } from './useSystemPackageVersionBuildStep.vm';

export function SystemPackageVersionBuildStep({
  control,
  applicationFiles,
  setFieldError,
  clearFieldError,
  getUploadingProgress,
}: SystemPackageVersionBuildStepProps): ReactNode {
  const { t } = useTranslation(ALL_LNGS_NAMESPACES.APPLICATION);
  const { inputOptions, allowedFileExtensions, isExistingAppFilesRequired, isApplicationFilesRequired } =
    useSystemPackageVersionBuildStep({
      applicationFiles,
      control,
    });

  const shouldDisplayExistingSystemPackage =
    !!inputOptions.existingAppFiles && inputOptions.existingAppFiles.length > 0;

  return (
    <DeviceAppVersionCard
      subtitle={t('subtitle.systemPackageFilesSection')}
      title={t('title.systemPackageVersionFiles')}
    >
      {shouldDisplayExistingSystemPackage && (
        <>
          <SystemPackageVersionSelectField
            clearFieldError={clearFieldError}
            control={control}
            label={t('input.existingSystemPackageFiles.label')}
            name={'build.existingAppFiles'}
            options={inputOptions.existingAppFiles}
            placeholder={t('input.existingSystemPackageFiles.placeholder')}
            required={isExistingAppFilesRequired}
          />
          <Divider />
        </>
      )}
      <SystemPackageVersionApplicationFilesField
        clearFieldError={clearFieldError}
        control={control}
        fileExtensions={allowedFileExtensions}
        maxFileSize={applicationFilesMaxFileSizeInMB}
        unitFileSize={applicationFilesUnit}
        required={isApplicationFilesRequired}
        setFieldError={setFieldError}
        getUploadingProgress={getUploadingProgress}
      />
    </DeviceAppVersionCard>
  );
}
